import * as React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  Stack,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
} from "@mui/material";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useLanguage } from "./Language";
import { IFormThemeValues } from "./pages/config/BrandingPage";

export interface HeaderCustomizationControlsProps {}

export const HeaderCustomizationControls: React.FC<
  HeaderCustomizationControlsProps
> = () => {
  const { translate } = useLanguage();
  const { control, getValues } = useFormContext<IFormThemeValues>();

  return (
    <Box>
      <Stack
        direction={"column"}
        spacing={1}
        sx={{
          justifyContent: "flex-start",
          alignItems: "left",
          maxWidth: "100%"
        }}>
        <Box
          sx={{
            justifyContent: "flex-start",
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="header-position-selector-label">
              {translate("libraryNamePosition")}
            </InputLabel>
            <Controller
              name="headerPosition"
              control={control}
              render={({ field }) => (
                <Select
                  {...field}
                  labelId="header-position-selector-label"
                  label={translate("libraryNamePosition")}
                  onChange={(e) => {
                    field.onChange(e);
                  }}
                >
                  <MenuItem value={"Top"}>
                    {translate("selectorTopPositionLabel")}
                  </MenuItem>
                  <MenuItem value={"Bottom"}>
                    {translate("selectorBottomPositionLabel")}
                  </MenuItem>
                </Select>
              )}
            />
          </FormControl>
        </Box>
        <FormControlLabel
          control={
            <Controller
              name="showHeaderOnMobile"
              control={control}
              render={({ field: { value, ...field } }) => {
                return <Checkbox checked={value} {...field} />;
              }}
            />
          }
          label={translate("displayHeaderOnMobileLabel")}
          sx={{ pb: 1 }}
        />
      </Stack>
    </Box>
  );
};

export default HeaderCustomizationControls;
